<app-modal-filler-atom
  (click)="close()"
  index="5"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 content-center max-w-screen-md mx-auto overflow-y-auto top-60 max-h-85-screen'"
  [style.z-index]="750"
>
  <div
    class="relative bg-white rounded-lg"
    [style.z-index]="(index$ | async) + 50"
  >
    <div class="absolute z-10 top-4 right-4">
      <app-rounded-icon-button
        icon="icon-cross"
        [overrideColor]="backgroundColor"
        size="md"
        type="outlined"
        [bold]="true"
        (onClick)="close()"
      ></app-rounded-icon-button>
    </div>
    <div class="relative flex items-center justify-center overflow-hidden rounded-t-lg h-96">
      <div class="absolute inset-0 bg-white">
        <div
          class="h-52"
          [style.backgroundColor]="accentColor | contentBuilderColor"
        ></div>
      </div>
      @if (image) {
        <img
          [src]="image"
          alt=" "
          class="relative z-10 object-cover h-auto shadow-lg aspect-square w-80"
        />
      }
    </div>
    <div
      class="flex flex-col items-center justify-center gap-5 pt-10 pb-24 mx-auto text-left max-w-80"
    >
      @if (name) {
        <p class="text-xl font-bold text-center">{{ name }}</p>
      }
      @if (price) {
        <app-price-atom
          size="XL"
          [amount]="price"
          [bold]="true"
        ></app-price-atom>
      }
      @if (description) {
        <p>
          {{ description }}
        </p>
      }
      @if (allergens?.length) {
        <div class="flex flex-col w-full gap-2">
          <p class="font-bold">{{ 'product-add-modal.allergens' | translate }}</p>
          <p>
            @for (allergen of allergens; track allergen.id; let last = $last) {
              {{ allergen.name }}{{ !last ? ', ' : '' }}
            }
          </p>
        </div>
      }
      @if (price) {
        <div class="flex flex-col items-center justify-center gap-4 py-4">
          @if (type === 'SIMPLE' && product?.additions.products.length === 0) {
            <app-counter-atom
              [type]="'kiosk'"
              [size]="'L'"
              [min]="1"
              [backgroundColor]="backgroundColor | contentBuilderColor"
              [textColor]="accentColor | contentBuilderColor"
              [(count)]="quantity"
            ></app-counter-atom>
            <app-button-atom
              [label]="'product-add-modal.add-to-cart' | translate"
              [type]="'kiosk-outlined'"
              [size]="'XXL'"
              [thickSize]="'S'"
              [overrideBgColor]="backgroundColor"
              [overrideTextColor]="accentColor"
              (click)="addToCart()"
            >
            </app-button-atom>
          } @else {
            <app-button-atom
              [label]="'product-add-modal.choose-declinable' | translate"
              [type]="'kiosk-outlined'"
              [size]="'XXL'"
              [thickSize]="'S'"
              [overrideBgColor]="backgroundColor"
              [overrideTextColor]="accentColor"
              (click)="onNavigateToProduct()"
            >
            </app-button-atom>
          }
        </div>
      }
    </div>
  </div>
</div>
